import * as types from './mutation-types'
import api from '@/modules/api'
import moment from 'moment-timezone'
import gqlClient from '@/modules/graphql'
import Promise from 'bluebird'

import {
  getMySchedulesQuery,
  getTimeOffsQuery,
  getAvailableShiftsQuery,
  getDashboardThisWeekStatsQuery,
  getRequests,
  getShiftRequests,
  getUserRequests,
  getMessages,
  getSwappableEmployees,
  getActualSalesByDuration,
  getDashboardMetricsStatsQuery,
  getDashboardLastWeekStatsQuery,
  getDashboardHotFloorStatsQuery,
  getRequestTypesQuery,
  messageRead,
  updateMessage,
  getLabourBudgetStatsQuery,
  getTodaySchedules,
  getTask,
  getMyTask,
  getEmployeeWSRequest,
  getStoreAssignedTasksQuery
} from './queries.graphql'


const actions = {
  async getMySchedules({
    commit
  }, variables = {}) {
    try {
      commit(types.GET_MY_SCHEDULES_BEGIN)
      const {
        data: {
          data: {
            appUser
          }
        }
      } = await gqlClient.query({
        query     : getMySchedulesQuery,
        variables : variables
      },{ timeout : 60000 })
      commit(types.GET_MY_SCHEDULES_SUCCESS, appUser)
    } catch (e) {
      commit(types.GET_MY_SCHEDULES_ERROR, e)
    }
  },

  async getUserAttendanceSummary({ commit }, userId) {
    try {
      commit(types.GET_USER_ATTENDANCE_SUMMARY_BEGIN)
      const { data } = await api.user.getAttendanceSummary(userId)
      commit(types.GET_USER_ATTENDANCE_SUMMARY_SUCCESS, data)
    } catch (e) {
      commit(types.GET_USER_ATTENDANCE_SUMMARY_ERROR, e)
    }
  },

  async getCurrentWeekTimeOffs({ commit }, variables = {} ){
    try {
      commit(types.GET_CURRENT_WEEK_TIME_OFFS_BEGIN)
      const {
        data: {
          data:{ store :{
            timeOffRequests
          } }
        }
      } = await gqlClient.query({
        query : getTimeOffsQuery,
        variables
      },{ timeout : 60000 })
      commit(types.GET_CURRENT_WEEK_OFFS_SUCCESS, timeOffRequests)
    } catch (e) {
      commit(types.GET_CURRENT_WEEK_OFFS_ERROR, e)
    }
  },

  async getNextWeekTimeOffs({ commit }, variables = {} ){
    try {
      commit(types.GET_NEXT_WEEK_TIME_OFFS_BEGIN)
      const {
        data: {
          data:{ store :{
            timeOffRequests
          } }
        }
      } = await gqlClient.query({
        query : getTimeOffsQuery,
        variables
      },{ timeout : 60000 })
      commit(types.GET_NEXT_WEEK_TIME_OFFS_SUCCESS, timeOffRequests)
    } catch (e) {
      commit(types.GET_NEXT_WEEK_TIME_OFFS_ERROR, e)
    }
  },

  async dropSchedule({ commit }, { uid,data }) {
    try {
      commit(types.DROP_SCHEDULE_BEGIN)
      const {
        data:responseData
      } = await api.user.createWorkscheduleRequest(uid,data)
      commit(types.DROP_SCHEDULE_SUCCESS, responseData)
    } catch (e) {
      commit(types.DROP_SCHEDULE_ERROR, e)
    }
  },
  async getAvailableShifts({
    commit
  }, variables = {}) {
    try {
      commit(types.AVAILABLE_SHIFTS_GET_REQUEST)
      const {
        data: {
          data: {
            appUser
          }
        }
      } = await gqlClient.query({
        query     : getAvailableShiftsQuery,
        variables : variables
      },{ timeout : 60000 })
      commit(types.AVAILABLE_SHIFTS_GET_SUCCESS, appUser)
    } catch (e) {
      commit(types.AVAILABLE_SHIFTS_GET_ERROR, e)
    }
  },
  async updateAvailableShifts({
    commit
  }, { uid,data }) {
    try {
      commit(types.AVAILABLE_SHIFTS_UPDATE_REQUEST)
      const {
        data:updateShift } = await api.user.updateWorkscheduleRequest(uid,data)
      commit(types.AVAILABLE_SHIFTS_UPDATE_SUCCESS, updateShift)
    } catch (e) {
      commit(types.AVAILABLE_SHIFTS_UPDATE_ERROR, e)
      throw new Error('Something Wrong')
    }
  },
  async applyOpenShiftRequest({
    commit
  }, { osId,userId }) {
    try {
      commit(types.APPLY_OPEN_SHIFT_REQUEST_BEGIN)
      const { data : { message } } = await api.user.createOpenShiftRequest(osId,userId)
      commit(types.APPLY_OPEN_SHIFT_SUCCESS, message)
    } catch (e) {
      commit(types.APPLY_OPEN_SHIFT_ERROR, e)
    }
  },
  async cancelOpenShiftRequest({
    commit
  }, { osId,userId }) {
    try {
      commit(types.CANCEL_OPEN_SHIFT_REQUEST_BEGIN)
      const { data : { message } } = await api.user.deleteOpenShiftRequest(osId,userId)
      commit(types.CANCEL_OPEN_SHIFT_SUCCESS, message)
    } catch (e) {
      commit(types.CANCEL_OPEN_SHIFT_ERROR, e)
    }
  },
  async getDashboardThisWeekStats({ commit ,rootState }){
    try {
      commit(types.GET_DASHBOARD_THIS_WEEK_STATS_BEGIN)
      
      if(!rootState.app.Store.id){
        return commit(types.GET_DASHBOARD_THIS_WEEK_STATS_FAILED, 'Store is not selected')
      }

      const { data:{ data:{ store } } } = await gqlClient.query({
        query     : getDashboardThisWeekStatsQuery,
        variables : {
          storeId : rootState.app.Store.id ,
          date    : moment().format('YYYY-MM-DD')
        }
      },{ timeout : 60000 })

      commit(types.GET_DASHBOARD_THIS_WEEK_STATS_SUCCESS, store)
    } catch (e) {
      commit(types.GET_DASHBOARD_THIS_WEEK_STATS_FAILED, e)
    }
  },
  async getDashboardLastWeekStats({ commit ,rootState }){
    try {
      commit(types.GET_DASHBOARD_LAST_WEEK_STATS_BEGIN)
      
      if(!rootState.app.Store.id){
        return commit(types.GET_DASHBOARD_LAST_WEEK_STATS_FAILED, 'Store is not selected')
      }

      const { data:{ data:{ store } } } = await gqlClient.query({
        query     : getDashboardLastWeekStatsQuery,
        variables : {
          storeId : rootState.app.Store.id ,
          date    : moment().format('YYYY-MM-DD')
        }
      },{ timeout : 60000 })

      commit(types.GET_DASHBOARD_LAST_WEEK_STATS_SUCCESS, store)
    } catch (e) {
      commit(types.GET_DASHBOARD_LAST_WEEK_STATS_FAILED, e)
    }
  },
  async getDashboardMetricsStats({ commit ,rootState }){
    try {
      commit(types.GET_DASHBOARD_METRICS_STATS_BEGIN)
      
      if(!rootState.app.Store.id){
        return commit(types.GET_DASHBOARD_METRICS_STATS_FAILED, 'Store is not selected')
      }

      const { data:{ data:{ store } } } = await gqlClient.query({
        query     : getDashboardMetricsStatsQuery,
        variables : {
          storeId : rootState.app.Store.id ,
          date    : moment().format('YYYY-MM-DD')
        }
      },{ timeout : 60000 })

      commit(types.GET_DASHBOARD_METRICS_STATS_SUCCESS, store)
    } catch (e) {
      commit(types.GET_DASHBOARD_METRICS_STATS_FAILED, e)
    }
  },
  async getActualSalesByDuration({ commit ,rootState }){
    try {
      commit(types.GET_DASHBOARD_ACTUAL_SALES_BEGIN)
      
      const selectedStore = rootState.app.Store

      if(!selectedStore.id){
        return commit(types.GET_DASHBOARD_ACTUAL_SALES_FAILED, 'Store is not selected')
      }

      const { data:{ data:{ store }, errors } } = await gqlClient.query({
        query     : getActualSalesByDuration,
        variables : {
          storeId : selectedStore.id ,
          date    : moment.tz(selectedStore.time_zone).format('YYYY-MM-DD')
        }
      },{ timeout : 60000 })

      if (errors) {
        return commit(types.GET_DASHBOARD_ACTUAL_SALES_FAILED, { errors })
      }

      commit(types.GET_DASHBOARD_ACTUAL_SALES_SUCCESS, store)
    } catch (e) {
      commit(types.GET_DASHBOARD_ACTUAL_SALES_FAILED, e)
    }
  },
  async getDashboardHotFloorStats({ commit ,rootState }){
    try {
      commit(types.GET_DASHBOARD_HOT_FLOOR_STATS_BEGIN)
      
      if(!rootState.app.Store.id){
        return commit(types.GET_DASHBOARD_HOT_FLOOR_STATS_FAILED, 'Store is not selected')
      }

      const { data: { data:{ store }, errors } } = await gqlClient.query({
        query     : getDashboardHotFloorStatsQuery,
        variables : {
          storeId : rootState.app.Store.id ,
          date    : moment().format('YYYY-MM-DD')
        }
      },{ timeout : 60000 })

      if(errors) {
        return commit(types.GET_DASHBOARD_HOT_FLOOR_STATS_FAILED, { errors })
      }

      commit(types.GET_DASHBOARD_HOT_FLOOR_STATS_SUCCESS, store)
    } catch (e) {
      commit(types.GET_DASHBOARD_HOT_FLOOR_STATS_FAILED, e)
    }
  },
  
  // @TODOS need to refactor in future. it should be moved into user-settings
  async getUserRequests({ commit }, { variables }){
    try {
      commit(types.GET_USER_REQUESTS_BEGIN)
      const { data: { data } } = await gqlClient.query({ query : getUserRequests, variables },{ timeout : 60000 })

      commit(types.GET_USER_REQUESTS_SUCCESS, data.appUser.userRequests)
    } catch (e) {
      commit(types.GET_USER_REQUESTS_FAILED, e)
    }
  },

  async getEmployeeWSRequest({ commit }, { userId, wsrId } ){
    try {
      commit(types.GET_EMPLOYEE_WS_REQUEST_BEGIN)
      const { data: { data } } = await gqlClient.query({ query : getEmployeeWSRequest,variables : { userId, wsrWhere : { id : wsrId } } },{ timeout : 60000 })

      commit(types.GET_EMPLOYEE_WS_REQUEST_SUCCESS, data.appUser.workScheduleRequests)
    } catch (e) {
      commit(types.GET_EMPLOYEE_WS_REQUEST_ERROR, e)
    }
  },

  async getRequests({ commit }, { variables } ){
    try {
      commit(types.GET_REQUESTS_BEGIN)
      const {
        data: {
          data
        }
      } = await gqlClient.query({
        query : variables.timeOffsOnly ? getTimeOffsQuery : getRequests,
        variables
      },{ timeout : 60000 })
      commit(types.GET_REQUESTS_SUCCESS, data.store.requests || data.store.timeOffRequests)
    } catch (e) {
      commit(types.GET_REQUESTS_FAILED, e)
    }
  },

  async getShiftRequests({ commit }, { variables } ){
    try {
      commit(types.GET_SHIFT_REQUESTS_BEGIN)
      const {
        data: {
          data
        }
      } = await gqlClient.query({
        query : getShiftRequests,
        variables
      },{ timeout : 60000 })
      commit(types.GET_SHIFT_REQUESTS_SUCCESS, data.store.requests)
    } catch (e) {
      commit(types.GET_SHIFT_REQUESTS_FAILED, e)
    }
  },

  async getSwappableEmployees({ commit }, variables){
    try {
      commit(types.GET_SWAPPABLE_EMPLOYEES_BEGIN)

      const { data:{ data:{ store }  } } = await gqlClient.query({
        query : getSwappableEmployees,
        variables
      },{ timeout : 60000 })

      commit(types.GET_SWAPPABLE_EMPLOYEES_SUCCESS,
        store.swappableEmployees)
    } catch (e) {
      commit(types.GET_SWAPPABLE_EMPLOYEES_FAILED, e)
    }
  },

  async deleteWorkScheduleRequest({ commit }, id){
    commit(types.DELETE_WORK_SCHEDULE_REQUEST_BEGIN)
    try {
      await api.workScheduleRequest.destroy(id)
      commit(types.DELETE_WORK_SCHEDULE_REQUEST_SUCCESS, id)
    } catch (error) {
      commit(types.DELETE_WORK_SCHEDULE_REQUEST_FAILED, error)
    }
  },

  async getMessages({ commit }, { type , variables }){
    const msgTypes = {
      MESSAGES : {
        BEGIN   : types.GET_MESSAGES_BEGIN,
        SUCCESS : types.GET_MESSAGES_SUCCESS,
        ERROR   : types.GET_MESSAGES_ERROR
      },
      NOTIFICATIONS : {
        BEGIN   : types.GET_NOTIFICATIONS_BEGIN,
        SUCCESS : types.GET_NOTIFICATIONS_SUCCESS,
        ERROR   : types.GET_NOTIFICATIONS_ERROR
      }
    }
    commit(msgTypes[type].BEGIN)
    try {
      const { data:{ data:{ appUser } } } =  await gqlClient.query({
        query : getMessages,
        variables
      },{ timeout : 60000 })

      commit(msgTypes[type].SUCCESS, appUser)
    } catch (error) {
      commit(msgTypes[type].ERROR, error)
    }
  },


  async updateMessageRead({ commit }, { messageId,type }){
    commit(types.UPDATE_MESSAGE_READ_BEGIN)
    try {
      const { data:{ data } } =  await gqlClient.query({
        mutation  : messageRead,
        variables : { messageId }
      },{ timeout : 60000 })
      commit(types.UPDATE_MESSAGE_READ_SUCCESS,{
        message : data.messageRead,type
      })
    } catch (error) {
      commit(types.UPDATE_MESSAGE_READ_FAILED, error)
    }
  },


  async updateMessage({ commit }, variables){
    commit(types.UPDATE_MESSAGES_BEGIN)
    try {
      const { data:{ data,errors } } =  await gqlClient.query({
        mutation : updateMessage,
        variables
      },{ timeout : 60000 })
      if(errors) {
        return commit(types.UPDATE_MESSAGES_FAILED, { errors })
      }
      commit(types.UPDATE_MESSAGES_SUCCESS,{
        message : data.updateMessage
      })
    } catch (error) {
      commit(types.UPDATE_MESSAGES_FAILED, error)
    }
  },

  async updateWorkScheduleRequest({ commit }, { id,data }){
    commit(types.UPDATE_WORK_SCHEDULE_REQUEST_BEGIN)
    try {
      await api.workScheduleRequest.update(id,data)
      commit(types.UPDATE_WORK_SCHEDULE_REQUEST_SUCCESS)
    } catch (error) {
      commit(types.UPDATE_WORK_SCHEDULE_REQUEST_FAILED, error)
    }
  },

  async getRequestTypes({ commit }, variables={}){
    try {
      commit(types.GET_REQUEST_TYPES_BEGIN)
      const {
        data: {
          data
        }
      } = await gqlClient.query({
        query : getRequestTypesQuery,
        variables
      },{ timeout : 60000 })
      commit(types.GET_REQUEST_TYPES_SUCCESS, data.company.requestTypes)
    } catch (e) {
      commit(types.GET_REQUEST_TYPES_FAILED, e)
    }
  },

  async deleteRequests({ commit }, variables={}){
    try {
      commit(types.DELETE_REQUEST_BEGIN)
      await api.requests.deleteRequest(variables)
      commit(types.DELETE_REQUEST_SUCCESS, variables)

    } catch (e) {
      commit(types.DELETE_REQUEST_FAILED, e)
    }
  },

  removeRequestFromState({ commit }, { id,wsrType }){
    commit(types.REMOVE_WORK_SCHEDULE_REQUEST,{ id,wsrType })
  },

  async getLaborBudgetStats({ commit }, variables={}){
    try {
      commit(types.GET_LABOR_BUDGET_STATS_BEGIN)

      const { storeId, ...options } = variables

      const [{ data: { punched, scheduled } }, { data:{ data:{ store:{ statistics } } } }] = await Promise.all([
        api.store.getPayrollData(storeId, options),
        gqlClient.query({ query : getLabourBudgetStatsQuery,variables },{ timeout : 60000 })
      ])

      commit(types.GET_LABOR_BUDGET_STATS_SUCCESS, { punched, scheduled, statistics })
    } catch (e) {
      commit(types.GET_LABOR_BUDGET_STATS_FAILED, e)
    }
  },

  async getStoreInsightsStats({ commit, rootState }){
    try {
      const storeId = rootState.app.Store.id

      if(!storeId){
        return commit(types.GET_STORE_INSIGHTS_STATS_FAILED, 'Store is not selected')
      }

      commit(types.GET_STORE_INSIGHTS_STATS_BEGIN)

      const { data } = await api.store.getAttendanceSummary(storeId)
      commit(types.GET_STORE_INSIGHTS_STATS_SUCCESS, data)
    } catch (e) {
      commit(types.GET_STORE_INSIGHTS_STATS_FAILED, e.message || e)
    }
  },
  async getTodayEmpSchedules({
    commit
  }, variables = {}) {
    try {
      commit(types.GET_TODAY_SCHEDULES_BEGIN)
      const {
        data: {
          data: {
            store
          }
        }
      } = await gqlClient.query({
        query     : getTodaySchedules,
        variables : variables
      },{ timeout : 60000 })
      commit(types.GET_TODAY_SCHEDULES_SUCCESS, store)
    } catch (e) {
      commit(types.GET_TODAY_SCHEDULES_ERROR, e)
    }
  },

  async getStoreAssignedTasks({
    commit
  }, variables = {}) {
    try {
      commit(types.GET_ASSIGNED_STORE_TASKS_BEGIN)
      const {
        data: {
          data: {
            store
          }
        }
      } = await gqlClient.query({
        query     : getStoreAssignedTasksQuery,
        variables : variables
      },{ timeout : 60000 })
      commit(types.GET_ASSIGNED_STORE_TASKS_SUCCESS, store)
    } catch (e) {
      commit(types.GET_ASSIGNED_STORE_TASKS_ERROR, e)
    }
  },

  async getAllTasks({
    commit
  }, variables = {}) {
    try {
      commit(types.GET_COMPLETED_TASKS_BEGIN)
      const {
        data: {
          data: {
            store
          }
        }
      } = await gqlClient.query({
        query     : getTask,
        variables : variables
      },{ timeout : 60000 })
      commit(types.GET_COMPLETED_TASKS_SUCCESS, store)
    } catch (e) {
      commit(types.GET_COMPLETED_TASKS_ERROR, e)
    }
  },

  async getUncompletedTasks({
    commit
  }, variables = {}) {
    try {
      commit(types.GET_UNCOMPLETED_TASKS_BEGIN)
      const {
        data: {
          data: {
            store
          }
        }
      } = await gqlClient.query({
        query     : getTask,
        variables : variables
      },{ timeout : 60000 })
      commit(types.GET_UNCOMPLETED_TASKS_SUCCESS, store)
    } catch (e) {
      commit(types.GET_UNCOMPLETED_TASKS_ERROR, e)
    }
  },

  async getUnassignedTasks({
    commit
  }, variables = {}) {
    try {
      commit(types.GET_UNASSIGNED_TASKS_BEGIN)
      const {
        data: {
          data: {
            store
          }
        }
      } = await gqlClient.query({
        query     : getTask,
        variables : variables
      },{ timeout : 60000 })
      commit(types.GET_UNASSIGNED_TASKS_SUCCESS, store)
    } catch (e) {
      commit(types.GET_UNASSIGNED_TASKS_ERROR, e)
    }
  },

  async getMyTasks({
    commit
  }, variables = {}) {
    try {
      commit(types.GET_MY_TASKS_BEGIN)
      const {
        data: {
          data: {
            appUser
          }
        }
      } = await gqlClient.query({
        query     : getMyTask,
        variables : variables
      },{ timeout : 60000 })
      commit(types.GET_MY_TASKS_SUCCESS, appUser)
    } catch (e) {
      commit(types.GET_MY_TASKS_ERROR, e)
    }
  },

  async updateMyTask({ commit }, { id,data }){
    try {
      commit(types.UPDATE_MY_TASK_BEGIN,id)
      await api.myTask.updateMyTask(id,data)
      commit(types.UPDATE_MY_TASK_SUCCESS,id)

    } catch (e) {
      commit(types.UPDATE_MY_TASK_FAILED, e,id)
    }
  },

  async getWeatherDetails({ commit }, storeId){
    try {
      commit(types.GET_WEATHER_DETAILS_BEGIN)
      const { data } = await api.store.getWeatherDetails(storeId)
      
      commit(types.GET_WEATHER_DETAILS_SUCCESS, data)

    } catch (e) {
      commit(types.GET_WEATHER_DETAILS_ERROR, e)
    }
  },
  async getUpcommingEmployeeSchedule({ commit }, params){
    try {
      commit(types.GET_EMPLOYEE_SCHEDULE_BEGIN)
      const { data } = await api[params.userId ? 'user': 'store'].getUpcommingEmployeeSchedule(params)

      commit(types.GET_EMPLOYEE_SCHEDULE_SUCCESS, data)
    } catch (e) {
      commit(types.GET_EMPLOYEE_SCHEDULE_ERROR, e)
    }
  },

}



export default actions
